<template>
  <product-item-form :items="ui"
                     :value="value"
                     :disabled="disabled"
                     :check-required="checkRequired"
                     :publish="publish"
                     @input="onChange"
                     @publish="$emit('publish')"
                     @submit="$emit('submit')"></product-item-form>
</template>

<script>
import ProductItemForm from '../ui/ProductItemForm'
import request from '../../api/request';

export default {
  name: 'ProductManagementFormWithType',
  components: {
    ProductItemForm
  },
  data() {
    return {
      ui: [],
    }
  },
  props: {
    type: String,
    value: Object,
    disabled: Boolean,
    checkRequired: Boolean,
    publish: Boolean
  },
  created() {
    request.product.post('ui_get_tmpl', { type: this.type }).then((r) => {
      this.ui = r.data
    })
  },
  methods: {
    onChange(v) {
      this.$emit('input', v)
    }
  }
}
</script>